<template>
  <label class="Checkbox" :class="[disabled && '--disabled', nor && '--nor']"
      @click.shift.prevent="selectRange"
      :data-name="name"
      @mousedown.shift.stop.prevent
  >
    <input type="checkbox" ref="input" :name="name" :value="set || value" @change="onChange" :disabled="disabled" />
    <div class="Checkbox__view" />
    <span v-if="label" class="Checkbox__label">{{label}}</span>
    <slot />
  </label>
</template>
<script>
import { Options, Prop, Vue, Watch } from 'vue-property-decorator';
import InputProto from './InputProto';

const lastByName = {};
const registry = new WeakMap();

@Options({
  name: 'Checkbox',
  mixins: [InputProto],
})
export default class Checkbox extends Vue {
  @Prop() value; // if its Array, it will mutate arr with push/splice, otherwise set value exlicitly
  @Prop() set; // what this Checkbox sets onchange
  @Prop(Boolean) nor; // when neither one nor the other
  @Prop({ type: Boolean, default: true }) strict;

  @Watch('value')
  handleChecking(v, o) {
    if (v === o && !Array.isArray(v))
      return;

    if (this.set$ !== undefined && Array.isArray(this.value))
      this.$refs.input.checked = ~this.value.indexOf(this.set$);
    else if (this.strict)
      this.$refs.input.checked = this.value === this.set$;
    else if (!this.strict)
      this.$refs.input.checked = !!this.value;
  }

  get set$ () {
    return this.set !== undefined ? this.set : true;
  }

  preventSelection (e) {
    document.onselectstart = function onSelectStart () { false };
    setTimeout(() =>
      document.onselectstart = null,
      100,
    );
  }

  selectRange () {
    if (!this.name)
      throw new Error('Checkbox should has uniq :name to use range selection');

    const $$all = [...this.$root.$el.querySelectorAll(`.Checkbox[data-name="${ this.name }"]`)];
    const fromInstance = lastByName[this.name];
    const from = $$all.indexOf(fromInstance.$el);
    const to = $$all.indexOf(this.$el);
    if (~from && ~to) {
      if (from === to)
        return this.toggle();

      const dir = from < to ? -1 : 1;
      const { checked } = fromInstance.$refs.input;
      for (let i = to; i !== from; i += dir)
        registry.get($$all[i])?.toggle(checked);
    }
    this.setLast();
  }

  setLast (name = this.name) {
    if (!name)
      return;
    lastByName[name] = this;
  }

  toggle (bool = !this.$refs.input.checked) {
    this.$refs.input.checked = bool;
    this.onChange();
  }

  onChange () {
    const { checked } = this.$refs.input;
    var value;
    if (Array.isArray(this.value)/* && this.set$ !== undefined*/) {
      var i = this.value.indexOf(this.set$);
      if (!~i && checked) {
        this.value.push(this.set$);
        // this.$emit('diff', this.set$, null);
      }
      else {
        this.value.splice(i, 1);
        // this.$emit('diff', null, this.set$);
      }
      value = this.value;
    }
    else {
      value = checked ? this.set$ : false;
    }

    this.$emitToField(value, 'input');
    this.$emitToField(value, 'blur');
    this.setLast();
  }

  mounted () {
    this.handleChecking(this.value);
    this.name && registry.set(this.$el, this);
  }

  unmounted () {
    registry.delete(this.$el, this);
  }
}

</script>
<style>

.Checkbox {
  --color: var(--brand);
  --color-out: var(--white-50);

  position: relative;
  display: inline-block;
  cursor: pointer;
/*  height: 16px;*/
  min-height: 16px;


  &.--blue {
    --color: var(--blue, rgb(90, 185, 249));
    --color-out: rgba(90, 185, 249, .5);
  }
  &.--green {
    --color: var(--green, rgba(156, 210, 109));
    --color-out: rgba(156, 210, 109, .5);
  }
  &.--pink {
    --color: var(--pink);
    --color-out: var(--pink);
  }
  &.--orange {
    --color: #856404bb;
    --color-out: #85640466;
  }

  > * {
    vertical-align: middle;
  }

  input {
    opacity: 0;
    position: absolute;
    width: 0;
    height: 0;
  }

  &__view {
    width: 16px;
    height: 16px;
    display: inline-block;

/*    border: 1px solid var(--black-50);*/
    border-radius: 2px;
    background: white;
    position: relative;
    transition: .2s all cubic-bezier(0.175, 0.885, 0.32, 1.275);
    vertical-align: top;
    /*transition-delay: 0.1s;*/

    &:after {
      content: '';
      position: absolute;
      left: 2px;
      top: 3px;
      width: 9px;
      height: 4px;
/*      border: 1px solid white;*/
      border-width: 0 0 2px 2px;
      transition: .3s all cubic-bezier(0.175, 0.885, 0.32, 1.275);
      transition-delay: 0.1s;

/*      transform: scale(0) rotate(-45deg);*/
    }
  }


  input:checked + &__view {
    transition-delay: 0;
    background: var(--color);
    border-color: var(--color);

    &:after {
      transition-delay: 0;
/*      transform: scale(1) rotate(-45deg);*/
    }
  }

  &.--nor input:checked + &__view:after {
/*    transform: scale(1) rotate(0deg);*/
    border-width: 0;
    height: 2px;
    background-color: var(--white);
    width: 10px;
    top: 6px;
  }

  input:disabled + &__view {
    background: var(--pale-grey);
    border-color: var(--pale-grey);
    /*&:after {
    }*/
  }

  input:focus + &__view {
    box-shadow: 0 0 0 3px var(--border-c-50);
  }

  input:checked:focus + &__view {
    box-shadow: 0 0 0 3px var(--color-out);
  }

  &__label {
    margin-left: 8px;
    display: inline-block;
    vertical-align: top;
  }
}

</style>